<template>
  <div id="OnboardingMain">
    <XyzTransition appear duration="auto" mode="out-in">
      <div>

    <div class="gfx-main">
    <div class="top-header xyz-nested" xyz="fade short-100% ease" >
      <img src="@/assets/svg/login/gfx2.svg" class="new-tag-image " />
    </div>
    <div class="top-header w-full xyz-nested" xyz="fade down-5 small-75% delay-2.5 duration-2" >
      <img src="@/assets/logo-long.png" class="top-logo"/>
    </div>
    </div>
    <div class="main-details" xyz="fade fade left-5 delay-5 duration-5 sease-out-back">
      <br/>
      <p class="xyz-nested"><span class="vnum">Download Our App!</span></p>
      <p class="xyz-nested">To get started, download the app for your device below!</p>

      <div class="app-group">
        <div class="xyz-nested app-store"  xyz="fade fade left-5 delay-5 duration-5 sease-out-back">
          <a href="https://apps.apple.com/us/app/bark-badge/id1603111724" target="_blank">
            <img src="@/assets/icons/apple-store.svg" />
          </a>
        </div>

        <div class="xyz-nested app-store"  xyz="fade fade left-5 delay-5 duration-5 sease-out-back">
          <a href="https://play.google.com/store/apps/details?id=com.app.barkbadge.barkbadge" target="_blank">
            <img src="@/assets/icons/play-store.svg" />
          </a>
        </div>
      </div>
      <hr width="80%" style="background-color: #ddd; margin:2rem auto;"/>

      <div>
        <p class="xyz-nested"><span class="vnum">How to get started with your HeyBuddy Tag</span></p>

        <ul class="xyz-nested get-started-list">
          <li> <span class="li-ord">1</span> <span class="li-text">Register your account. (If you are a returning user, you can use your login)</span></li>
          <li> <span class="li-ord">2</span> <span class="li-text">Press the <img class="inline-icon" src="@/assets/icons/add-a-pet.svg"/> Icon</span></li>
          <li> <span class="li-ord">3</span> <span class="li-text">Scan <img class="inline-icon" src="@/assets/icons/qr-code.svg" />or Tap <img class="inline-icon" src="@/assets/icons/contactless.svg" /> the back of your HeyBuddy</span></li>
          <li> <span class="li-ord">4</span> <span class="li-text">Add your pet's info, and complete!</span></li>
          <li> <span class="li-ord">5</span> <span class="li-text">Enjoy your pet's profile</span></li>
        </ul>

        <!-- <p class="xyz-nested change-notice"><strong>NOTICE:</strong> If you were a beta tester of our web app, <strong>we will be discontinuing login access for the web app in May</strong>. We suggest you download o ur mobile app for improved performance and better user experience! Don't worry! You can still <strong>view your pet's profile via guest view by the web app</strong> and <strong>share the link</strong> to show off your pet to anyone who's not yet on the app! </p> -->

      </div>

    <p class="xyz-nested s-m-announce">Follow us on Social Media</p>

    <div class="social-group">
      <a href="https://www.twitter.com/heybuddyclub" target="_blank" class="xyz-nested social-page" xyz="fade fade left-5 delay-5 duration-5 sease-out-back">
        <img src="@/assets/social/twitter.svg" />
      </a>

      <a href="https://www.instagram.com/heybuddy.club" target="_blank" class="xyz-nested social-page" xyz="fade fade left-5 delay-5 duration-5 sease-out-back">
        <img src="@/assets/social/instagram.svg" />
      </a>

      <a href="https://www.facebook.com/heybuddytags" target="_blank" class="xyz-nested social-page" xyz="fade fade left-5 delay-5 duration-5 sease-out-back">
        <img src="@/assets/social/facebook.svg" />
      </a>

      <a href="https://www.tiktok.com/@heybuddy.club" target="_blank" class="xyz-nested social-page" xyz="fade fade left-5 delay-5 duration-5 sease-out-back">
        <img src="@/assets/social/tik-tok.svg" />
      </a>
    </div>

    <div xyz="fade small stagger delay-5 duration-5 ease-out-back">
      <button @click="gotoAffiliate()" class="new-tag-btn xyz-nested">
        <img class="btn-print heart" src="@/assets/svg/login/heart.svg" />
        Refer a friend!
          <img class="btn-print paw" src="@/assets/svg/login/paws.svg" />
      </button>
      <br />
      <p class="xyz-nested"><span class="vnum">You will be rewarded $5 for everyone who uses your code!</span></p>
    </div>

    </div>
  </div>
    </XyzTransition>
  </div>
</template>

<script>
//This component only direct the user from tag id to username
// import {fs, db} from '@/_firebase/init'
import {mapState, mapMutations} from 'vuex'
// import ClipLoader from 'vue-spinner/src/ClipLoader.vue'

export default {
  name: 'OnboardingMain',
  components: {
    // 'vue-spinner': ClipLoader
  },
  data(){
    return{
      showConfirmModal: false,
      pets_owned: [],
      ownerdata: {
        id: '',
        name:'',
        phone:'',
        address: '',
      },
      connected_pet_id: '',
      pets:[{photo:'', name: ''}],
      loading: true,
      processing: false,
      tag_id: this.$route.params.id,
      newScan: false,
      noAssignedPet: false
    }
  },
  watch:{
    // pets_owned(nv,ov){
    //   console.log(nv, ov)
    //   for(let pid of nv){
    //     this.getPetData(pid)
    //   }
    // }
  },
  methods:{
    ...mapMutations(['SET_ONBOARDING_POINT']),
    gotoStore(){
      // this.$router.push({name: 'Onboarding1'})
      window.open('https://heybuddy.club/', '_self')
    },
    gotoAffiliate(){
      window.open('https://affiliate.heybuddy.club/', '_self')
    }
  },
  computed:{
    ...mapState(['userID', 'new_tag', 'version_number']),
  },
  created(){
    if(this.onboarding_point > 0){
      this.$router.push({name: 'Onboarding2'})
    }
    this.SET_ONBOARDING_POINT(0)
    // this.getDeviceData()
  },
}
</script>
<style scoped>

#OnboardingMain{
  margin: auto;
  padding: 1rem;
  max-width: 900px;
  min-height: 100vh;
  background-color: #fff;
  margin-bottom: 3rem;
}
.social-group{
  display: flex;
  justify-content: space-between;
  width: 80%;
  margin: 0 auto;
  margin-top: 2rem;
}
.s-m-announce{
  margin-top: 3rem;
  font-size: 1.6rem;
  font-weight: bold;
  color: var(--primary);
}
.social-page img{
  width: 50px;
  margin:0 auto;
}
.app-group{
  display: flex;
  justify-content: space-between;
  width: 80%;
  margin: 0 auto;
  margin-top: 2rem;
}
.app-store{
  cursor: pointer;
}
.app-store img{
  width: 80%;
  margin:0 auto;
  transition: 1s;
  /* width: 300px; */
}
.app-store img:hover{
  transform: scale(1.35);
}
.gfx-main{
  width: 60%;
  text-align:center;
  margin-top: 0;
  margin: 2rem auto;
}
.top-header{
  text-align:center;
  width: 100%;
  margin:0 auto;
}
.top-header img{
  margin:2rem auto;
  text-align: center;
}
.new-tag-image{
  width: 80%;
  margin: 0 auto;
}
.top-logo{
  margin-top: 3rem;
  margin-bottom: -2rem;
  width: 20rem;
}
.new-tag-title{
  margin: 1rem;
  font-size: 2.4rem;
  color: var(--primary);
}
.tag-id{
  margin: 1rem;
}
.main-details{
  width: 80%;
  text-align:center;
  margin: 1rem auto;
}
.vnum{
  font-size: 1.6rem;
  font-weight: bold;
  color: var(--primary);
}
.get-started-list{
  list-style-type: none;
  color: #54545f;
  text-align: left;
  font-size: 1.15rem;
  width: 96%;
  margin: 2rem auto;
}
.get-started-list li{
  margin: 1rem 0;
  display: flex;
  align-items: flex-start;
}
.li-ord{
  background-color: #000;
  color:#fff;
  border-radius: 100%;
  font-size: .8rem;
  padding: .25rem .55rem;
  margin-right: .5rem;
}
.li-text{
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.inline-icon{
  width: 1.5rem;
  margin-bottom: -1rem;
  margin: 0 .3rem;
}
.change-notice{
  color: #54545f;
  text-align: left;
  width: 90%;
  margin: 1rem auto;
}
.change-notice strong{
  color: #000;
}
.new-tag-btn{
  background-color: var(--primary);
  text-align:center;
  border: none;
  text-decoration: none;
  position: relative;
  overflow: hidden;
  border-radius: 10px;
  font-size: 1.4rem;
  padding: 1.2rem 2rem;
  color: #fff;
  width: 80%;
  margin: 3rem auto;
  cursor: pointer;
  transition: 1s;
  cursor: pointer;
  box-shadow: 0 0 0 0 rgba(#222, .5);
  -webkit-box-shadow: 0 0 0 0 rgba(#222, .5);
  -webkit-animation: pulse 1.5s infinite;
  animation: pulse 2s infinite;
}
.btn-print{
  width: 3rem;
  position:absolute;
  opacity: .2;
}
.paw{
  bottom: 0rem;
  right: 1rem;
  transform: rotate(-30deg);
}
 .heart{
  top: .5rem;
  left: 1rem;
  transform: rotate(30deg);
}

.new-tag-btn:hover {
  -webkit-animation: none;
  animation: none;
}

@keyframes pulse {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(59,57,162, 0.7);
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(59,57,162, 0);
  }

  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(59,57,162, 0);
  }
}
@media only screen and (max-width: 900px) {
  .vnum{
    font-size: 1.2rem;
  }
  .change-notice{
    font-size: .8rem;
  }
  .s-m-announce{
    margin-top: 3rem;
    font-size: 1.3rem;
  }
  .app-group{
    width: 90%;
    margin-top: 1rem;
  }
  .app-store img{
    width: 120px;
  }
  .main-details{
    width: 85%;
    margin: .5rem auto;
    margin-top: -3rem;
  }
  .new-tag-btn{
    font-size: 1.2rem;
    padding: 1.2rem 1.2rem;
  }
  .gfx-main{
    width: 80%;
  }
  .btn-print{
    width: 2rem;
    position:absolute;
    opacity: .2;
  }
  .new-tag-title{
    font-size: 2rem;
  }
  .social-page img{
    width: 25px;
    margin:0 auto;
  }
  .top-logo{
    width: 13rem;
    margin-bottom: -4rem;
  }
  .top-header img{
    margin-top: 1rem;
  }
}
</style>
